import React from "react";
import imgSpinner from "../../assets/images/loading.gif";

const Spinner = ({ height = "50vh" }) => (
  <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: height }}>
    <img src={imgSpinner} style={{ width: "100px", margin: "auto", display: "block" }} alt="Loading..." />
  </div>
);
export default Spinner;
